import { ContentContainer, Loading, useLoading } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFeedback } from '../../hooks/useFeedback';
import { EmbeddedIframe } from '../shared/EmbeddedIframe';
import { usePages } from '../../hooks/usePages';

export function DashboardPanelPage() {
  const { panelKey } = useParams();
  const [reportUrl, setReportUrl] = useState<string>();
  const { loading, startLoading, stopLoading } = useLoading();
  const { getPanelUrlByNavKey } = usePages();
  const { showFailFeedback } = useFeedback();

  useEffect(() => {
    if (!panelKey || panelKey === ':panelKey') return;
    startLoading();
    try {
      fetch(getPanelUrlByNavKey(panelKey))
        .then((response) => response.json())
        .then((response) => {
          if (response.EmbedUrl) setReportUrl(response.EmbedUrl);
          else showFailFeedback(response);
        })
        .catch((error) => {
          console.log(error);
          showFailFeedback('Ups... Algo salio mal!');
        })
        .finally(() => {
          stopLoading();
        });
    } catch (error) {
      showFailFeedback('Ups... Algo salio mal!');
      stopLoading();
    }
  }, [panelKey]);

  if (!panelKey || panelKey === ':panelKey') return;

  return (
    <ContentContainer>
      {loading && <Loading />}
      {!loading && reportUrl && <EmbeddedIframe url={reportUrl} />}
    </ContentContainer>
  );
}
